import { isNullOrUndefined, extractHostname, containsAny } from "/Assets/js/utilities.js";
import utmTracking from "./utm-tracking.js";

export default class LeadSource {
    constructor(embeddedFormFields) {
        this.embeddedFormFields = embeddedFormFields;
    }

    setLeadSource() {
        if (this.embeddedFormFields.get("leadsource") === "undefined" &&
            this.embeddedFormFields.get("leadsourcedetail") === "undefined")
            return;

        const leadSourceValues = this.getLeadSourceValues();

        if (this.embeddedFormFields.get("leadsource") !== "undefined") {
            const leadSourceId = this.embeddedFormFields.get("leadsource");
            const leadSourceSelect = document.getElementById(leadSourceId);

            if (leadSourceSelect !== null) {
                const leadSource = leadSourceValues[0]["ls"];

                if (!isNullOrUndefined(leadSource)) {
                    for (let i = 0; i < leadSourceSelect.options.length; i++) {
                        if (leadSourceSelect.options[i].text.toLowerCase() === leadSource.toLocaleLowerCase()) {
                            leadSourceSelect.selectedIndex = i;
                            break;
                        }
                    }
                }
            }
        }

        if (this.embeddedFormFields.get("leadsourcedetail") !== "undefined") {
            const leadSourceDetailId = this.embeddedFormFields.get("leadsourcedetail");
            const leadSourceDetailSelect = document.getElementById(leadSourceDetailId);

            if (leadSourceDetailSelect !== null) {
                const leadSourceDetail = leadSourceValues[0]["lsd"];

                if (!isNullOrUndefined(leadSourceDetail)) {
                    for (let i = 0; i < leadSourceDetailSelect.options.length; i++) {
                        if (leadSourceDetailSelect.options[i].text.toLowerCase() === leadSourceDetail.toLowerCase()) {
                            leadSourceDetailSelect.selectedIndex = i;
                            break;
                        }
                    }
                }
            }
        }
    }

    getLeadSourceValues() {
        let utmMedium;
        let utmSource;

        if (utmTracking.utmPresentInUrl()) {
            utmMedium = utmTracking.getParameterByName("utm_medium");
            utmSource = utmTracking.getParameterByName("utm_source");
        } else {
            utmMedium = utmTracking.utmMedium();
            utmSource = utmTracking.utmSource();
        }

        const vars = [];

        if (isNullOrUndefined(utmMedium) && isNullOrUndefined(utmSource)) {
            const referrer = document.referrer;
            const hostname = extractHostname(referrer).toLowerCase();

            if (referrer !== "") {
                const searchEngine = containsAny(referrer,
                    [
                        "google",
                        "bing",
                        "baidu",
                        "yahoo",
                        "ask",
                        "duckduckgo",
                        "naver",
                        "sogou"
                    ]);
                const socialPlatform = containsAny(referrer,
                    [
                        "facebook",
                        "youtube",
                        "linkedIn",
                        "instagram",
                        "twitter",
                        "wechat",
                        "pinterest"
                    ]);
                const hyperthermSite = containsAny(referrer, ["hypertherm.com"]);
                const haSite = containsAny(referrer, ["hyperthermassociates.com"]);
                const rmSite = containsAny(referrer, ["robotmaster.com"]);
                const omaxSite = containsAny(referrer, ["omax.com"]);
                const fastSpringSite = containsAny(referrer, ["onfastspring.com"]);

                if (searchEngine !== null && haSite === null && hyperthermSite === null && rmSite === null) {
                    vars.push({ ls: "organic search", lsd: searchEngine });
                } else if (socialPlatform !== null && haSite === null && hyperthermSite === null && rmSite === null) {
                    vars.push({ ls: "social", lsd: socialPlatform });
                } else if (haSite !== null) {
                    vars.push({ ls: "website", lsd: "hyperthermassociates.com" }); //
                } else if (hyperthermSite !== null) {
                    vars.push({ ls: "website", lsd: "hypertherm.com" });
                } else if (rmSite !== null) {
                    vars.push({ ls: "website", lsd: "robotmaster.com" });
                } else if (omaxSite !== null) {
                    vars.push({ ls: "website", lsd: "omax.com" });
                } else if (hostname === "t.co") {
                    vars.push({ ls: "social", lsd: "twitter" });
                } else if (fastSpringSite !== null) {
                    vars.push({ ls: "referral", lsd: "fastspring" });
                } else {
                    vars.push({ ls: "referral", lsd: "other referral" });
                }
            } else {
                vars.push({ ls: "other", lsd: "website-other" });
            }
        } else {
            const ls = utmMedium !== undefined ? decodeURI(utmMedium) : "";
            const lsd = utmSource !== undefined ? decodeURI(utmSource) : "";
            vars.push({ ls: ls, lsd: lsd });
        }
        return vars;
    }
}
